import { useContext } from "react";
import { createPortal } from "react-dom";
import { AppContexts } from "../../providers";
import { WorkOrderProvider } from "../../providers/workorders.provider";
import WorkOrderAdd from "./work_order_add";

const CreateTaskAction = ({ source }) => {
  const context = useContext(AppContexts.WorkOrderContext);

  const handleCreate = () => {
    context.setIsNew(true);
    context.initWorkOrder();
    // Only carry location context into the new task, never the source ID or progress.
    context.setWorkOrder({
      status: "new",
      priority: "medium",
      summary: "",
      description: "",
      rental_id: source.rental_id || source.rental?.rental_id,
      rental: source.rental,
      guest_reservation_id: source.guest_reservation_id || source.guest_reservation?.guest_reservation_id || source.guest_reservation?.id,
      guest_reservation: source.guest_reservation,
    });
    context.getAttributes();
  };

  return (
    <>
      <button
        type="button"
        className="uk-button hms-btn hms-white-btn no-print"
        uk-toggle="target: #work-order-add"
        onClick={handleCreate}
      >
        + Task
      </button>
      {createPortal(<WorkOrderAdd showTaskType showDelete={false} />, document.body)}
    </>
  );
};

// Keep the add form's selected task and loading state separate from the detail.
const CreateTaskFromDetail = ({ source }) => (
  <WorkOrderProvider>
    <CreateTaskAction source={source} />
  </WorkOrderProvider>
);

export default CreateTaskFromDetail;
